import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (FB650, FB651, FB652)
// ============================================================

export interface FB651 {
  fb651_01: string;        // 主表單號 (FK)
  fb651_02: number;        // 項次
  fb651_04: string | null; // 日期
  fb651_07: string;        // 部門代號
  fb651_11: string;        // 產品代號
  fb651_11a: string;       // 產品名稱
  fb651_12: string;        // 單位
  fb651_13: number;        // 數量
  fb651_14: number;        // 單價
  fb651_15: number;        // 金額
  fb651_18: string;        // 摘要
  fb651_85: boolean;       // 簽收狀態
  fb651_90: number;        // 版本
  fb651_91: string;        // 修改人
  fb651_93: string;        // 建立人
}

export interface FB652 {
  fb652_01: string;        // 主表單號 (FK)
  fb652_02: number;        // 序號
  fb652_03: string;        // 留言內容
  fb652_11: string;        // 發送人代號
  fb652_11a: string;       // 發送人名稱
  fb652_12: string | null; // 發送日期
  fb652_13: string;        // 受言人代號
  fb652_14: string | null; // 受言日期
}

export interface FB650 {
  fb650_01: string;        // 單號 (PK)
  fb650_07: string;        // 公司代號
  fb650_10: string;        // 領用部門
  fb650_11: string | null; // 領用日期
  fb650_12: string;        // 領用人員代號
  fb650_13: string;        // 欄位13
  fb650_14: string;        // 欄位14
  fb650_15: string;        // 說明
  fb650_16: number;        // 項數
  fb650_17: number;        // 合計金額
  fb650_30: string;        // 備註
  fb650_31: string;        // 類型 (空=B255, M=月, P=專案)
  fb650_41: number;        // 留言筆數
  fb650_42: number;        // 文具用途
  fb650_80: string;        // 核准狀態 (N=未核准, P=核准, B=沖銷)
  fb650_81: string;        // 核准/沖銷人員
  fb650_82: string | null; // 核准/沖銷日期
  fb650_90: number;        // 版本
  fb650_91: string;        // 修改人
  fb650_92: string | null; // 修改時間
  fb650_93: string;        // 建立人
  details?: FB651[];
  messages?: FB652[];
}

export interface CreateRequest {
  master: Omit<FB650, 'details' | 'messages'>;
  details: Omit<FB651, 'fb651_01' | 'fb651_02'>[];
  messages: Omit<FB652, 'fb652_01' | 'fb652_02'>[];
}

export interface UpdateRequest {
  master: Omit<FB650, 'details' | 'messages'>;
  details: Omit<FB651, 'fb651_01' | 'fb651_02'>[];
  messages: Omit<FB652, 'fb652_01' | 'fb652_02'>[];
}

export interface ListResponse {
  data: FB650[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API Methods
// ============================================================

export const b255Api = {
  list(page = 1, pageSize = 20): Promise<ListResponse> {
    return apiClient.get('/api/b255', { params: { page, pageSize } }).then(r => r.data);
  },

  search(keyword: string, page = 1, pageSize = 20): Promise<ListResponse> {
    return apiClient.get('/api/b255', { params: { keyword, page, pageSize } }).then(r => r.data);
  },

  get(id: string): Promise<FB650> {
    return apiClient.get(`/api/b255/${id}`).then(r => r.data);
  },

  create(req: CreateRequest): Promise<FB650> {
    return apiClient.post('/api/b255', req).then(r => r.data);
  },

  update(id: string, req: UpdateRequest): Promise<FB650> {
    return apiClient.put(`/api/b255/${id}`, req).then(r => r.data);
  },

  delete(id: string): Promise<void> {
    return apiClient.delete(`/api/b255/${id}`).then(() => undefined);
  },
};
